import * as React from 'react';
import { Grid } from '@material-ui/core';

import { FormSelect, FormTextField } from '../../../components';
import { PRODUCT_LIST_ACCESS_TYPE_FILTER_OPTIONS } from "../../../constants";

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="products-list-filter-by-name"
      data-apim-test="products-list-filter-by-name"
    />
  </Grid>
);

export const FilterByAccessType = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="product-filter-by-access-type"
      data-apim-test="product-filter-by-access-type"
      data={PRODUCT_LIST_ACCESS_TYPE_FILTER_OPTIONS}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);
